import { useTranslation } from "react-i18next";
import { IOutletContext } from "../utils/interfaces/IOutletContext";
import { useOutletContext } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../utils/redux/userSlice";
import SoftwareVersions, { SoftwareVersion } from "../components/SoftwareVersionsComponent/SoftwareVersions.component";
import { ISelectOptions } from "aw-combobox";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { Machine } from "../utils/models/Machine";
import { getAllMachines } from "../utils/services/machine.service";
import { AWGrid, TableData } from "aw-grid";
import { formatNumberWithLeadingZeros } from "aw-generic-functions";
import { AWSelect } from "aw-select";
import { useTheme } from "../utils/contexts/ThemeContext";
import { getTodayDate } from "aw-date-functions";
import ScheduleUpdate from "../components/ScheduleUpdate/ScheduleUpdate.component";

const UpdateModulePage = () => {
    const { t } = useTranslation();
    const user = useSelector(selectUser)
    const context: IOutletContext = useOutletContext();
    const [versions, setVersions] = useState<SoftwareVersion[]>([{ idversion: 1, version: '7.9.0.1.0.1.0', crc: '5DF8', date: '2025-01-01' }, { idversion: 2, version: '7.5.0.2.0.3.0', crc: '855D', date: '2025-01-01' }, { idversion: 3, version: '8.1.0.1.0.1.0', crc: '5DFR', date: '2025-01-01' }])
    const [versionsObj, setVersionsObj] = useState<ISelectOptions[]>([])
    const [selectedVersion, setSelectedVersion] = useState<ISelectOptions>({ label: 'No Version', value: 0 })
    const [machines, setMachines] = useState<Machine[]>([])
    const [machine, setMachine] = useState<Machine>(new Machine())
    const [machinesObj, setMachinesObj] = useState<ISelectOptions[]>([])
    const [selectedMachine, setSelectedMachine] = useState<ISelectOptions>()
    const [updateTime, setUpdateTime] = useState('10:00')
    const [tableData, setTableData] = useState<TableData[]>([])

    const tableHeaders = [t('Identifier'), t('Installation'), t('NSerie'), 'V. Firmware HMI']


    useEffect(() => {
        context.setState(t('RemoteUpdate'));
    }, [context, t])

    useEffect(() => {
        getAllMachines(user.token)
            .then((machines: Machine[]) => setMachines(machines))
            .catch((e) => console.log('Error get machines', e))
    }, [])

    useEffect(() => {
        if (machines.length > 0) {
            const mObj: ISelectOptions[] = []
            const tData: TableData[] = []
            machines.forEach((m) => {
                mObj.push({ value: m.idmachine, label: m.name })
                tData.push({ active: true, item: [m.idmachine, formatNumberWithLeadingZeros(m.idmachine, 5), m.instalation.name, m.serial_number, m.v_firmware_hmi] })
            })
            setTableData(tData)
            setMachinesObj(mObj)
            setSelectedMachine(mObj[0])
        } else
            setMachinesObj([])
    }, [machines])

    useEffect(() => {
        const machine = machines.find((m) => m.idmachine === selectedMachine?.value) || new Machine()
        setMachine(machine)
    }, [selectedMachine])

    useEffect(() => {
        if (versions.length > 0) {
            const vObj: ISelectOptions[] = []
            versions.forEach((v) => {
                vObj.push({ value: v.idversion, label: v.version })
            })

            setVersionsObj(vObj)
        }
    }, [versions])

    const updateVersionList = (vObj: string) => {
        //Get the added version from the SoftwareVersions component
        //Add the version to the versions array
        //Update the versionsObj array
        const newVersion: SoftwareVersion = { idversion: versions.length + 1, version: vObj, crc: '63FW', date: getTodayDate() }
        setVersions([...versions, newVersion])
        
    }

    const theme = useTheme();

    const dark = theme.theme === 'dark';

    return (
        <>
            <div className='row border-0 ms-1 me-1' style={{ maxWidth: '100%' }}>
                <div className="col-12 col-sm-5 p-1">
                    <SoftwareVersions versions={versions} updateVersionList={updateVersionList}/>
                </div>
                <div className="col-12 col-sm-7 p-1">
                    <ScheduleUpdate versions={versions}/>
                </div>
            </div>
        </>
    )
}



export default UpdateModulePage;
